document.querySelector('.teaser__button')?.addEventListener('click', () => {
    document.querySelector('.teaser')?.remove();
});

